module.exports = "<div>\n  <div class=\"Info Info-Loaded\" ng-class=\"{ 'is-withStaticMenu': ctrl.$state.current.name === 'info' }\">\n    <div class=\"Info-container Info-container--padding\" ui-view=\"info\" autoscroll></div>\n    <sa-info-menu is-static=\"ctrl.$state.current.name === 'info'\"></sa-info-menu>\n  </div>\n  <sa-content-loader class=\"Info-Loading\"></sa-content-loader>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/modules/info/info.html
// module id = 964
// module chunks = 4